export let WarningModalName;

(function (WarningModalName) {
  WarningModalName["CONFIRM_OPEN"] = "confirm_open";
})(WarningModalName || (WarningModalName = {}));